<video playsinline autoplay muted loop>
  <source src="assets/img/cry.mp4" type="video/mp4">
  <div class="mask"></div>
</video>

<div class="video-overlay flex-center">
  <div class="text-center">
    <h2 translate>SOSORRY.TITLE</h2>
    <h3 class="my-5" translate>SOSORRY.TEXT</h3>
    <a [routerLink]="['/','in','decision']" class="btn btn-rounded btn-default" translate>SOSORRY.BUTTON</a>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/so-sorry/so-sorry.component.html